import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export function ProductSpotPrice(props) {
	return {
		componentName: 'ProductSpotPrice',
		componentId: uuidv4(),
		props: _.merge(
			{
				message: '{spotPriceValue}',
			},
			props,
		),
	};
}
